var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modules && _vm.modules['invoices'])?_c('span',[_c('fa-icon',{class:{..._vm.iconSize, clickable: true},attrs:{"icon":"file-pdf"},on:{"click":_vm.getPdf}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }